<template>
<v-main>
  <v-hover>
    <template v-slot:default="{ hover }">
      <v-card
        outlined
        min-width="100%"
        class="mb-4 pa-4"
        :elevation="hover ? 2 : 0"
      >
        <v-row class="body-2" no-gutters align="center">
          <v-col cols="2">
            <v-img
              :src="product.itemId.images[0].imageSrc"
              :lazy-src="product.itemId.images[0].imageSml"
              width="120px"
              contain
            />
          </v-col>
          <v-col cols="3">
            <h4 class="h4">
              <router-link
                :to="{
                  name: 'Product',
                  params: { productTitle: product.itemId.title }
                }"
                style="text-decoration: none;"
                class="greend--text"
              >
                {{ product.itemId.title }}
              </router-link>
              <br />
              <span class="body-2" style="color: rgba(0, 0, 0, 0.6)">
                {{ product.itemId.size }}{{ product.itemId.sizeUnit }}</span
              >
            </h4>
          </v-col>
          <v-col cols="2" class="text-center">
            {{ product.itemId.price.toFixed(2).replace(".", ",") }} €
          </v-col>
          <v-col cols="2" class="text-center">
            <v-row no-gutters class="mx-2">
              <v-col cols="12" sm="4" order="last" order-sm="first">
                <v-btn
                  icon
                  @click="decreaseCount(product.itemId)"
                  x-small
                  :disabled="quantity > 1 ? false : true"
                >
                  <v-icon small>mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4">
                {{ quantity }}
              </v-col>
              <v-col cols="12" sm="4" order="first" order-sm="last">
                <v-btn icon @click="increaseCount(product.itemId)" x-small>
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2" class="text-center font-weight-bold">
            {{ (product.itemId.price * quantity).toFixed(2).replace(".", ",") }}
            €
          </v-col>
          <v-col cols="1" class="text-right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="deleteOverlay = true"
                  x-small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span> entfernen</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </v-hover>
  <v-dialog
      v-model="deleteOverlay"
      max-width="400"
      @keyup.esc="deleteOverlay = false"
    >
        <v-card>
            <v-card-title class="greend justify-center">
                <v-icon size="100" class="my-2" color="white">mdi-comment-question-outline</v-icon>
            </v-card-title>
            <v-card-title class="headline greend--text">Artikel entfernen?</v-card-title>
            <v-card-text>Möchten Sie {{ product.itemId.title }} wirklich aus dem Warenkorb entfernen?</v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn
                    text
                    @click="deleteOverlay = false"
                    class="ma-2"
                >
                    Abbrechen
                </v-btn>
                <v-btn
                    color="greend"
                    @click="removeArticle"
                    class="ma-2"
                    dark
                >
                    <v-icon left>mdi-delete</v-icon>Entfernen
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
export default {
  data() {
    return {
      deleteOverlay: false,
    };
  },
  props: {
    product: Object,
    quantity: Number,
    updateCart: Function,
    btnAction: String,
    i: Number
  },
  methods: {
    removeArticle() {
      this.$ga.event("Cart", this.product.itemId.title + " aus Warenkorb entfernt", this.product.itemId.title + "aus Warenkorb entfernt (Cart)");
      this.$store.commit("removeArticleFromCart", this.product.itemId.title);
      this.deleteOverlay = false
    },
    increaseCount(index, quantity = 1) {
      this.$ga.event("Cart", this.product.itemId.title + " Anzahl erhöht (auf " + (this.quantity + 1) + ")", this.product.itemId.title + " +1 (jetzt " + this.quantity + ")");
      this.$store.commit("addItemToCart", { itemId: index, quantity });
    },
    decreaseCount(index, quantity = 1) {
      this.$ga.event("Cart", this.product.itemId.title + " Anzahl verringert (auf " + (this.quantity -1) + ")", this.product.itemId.title + " -1 (jetzt " + this.quantity + ")");
      this.$store.commit("removeItemFromCart", { itemId: index, quantity });
    }
  }
};
</script>
